module.exports = __webpack_public_path__ + "images/bannerEN-f2e734c3f8147d39439f994f7733c919.jpg";